import {secureFetch} from './authService';
import {API_BASE_URL} from './constants';

const DEFAULT_COUNTRY_CODE = '';

export function getCountries(query) {
    let url = API_BASE_URL + '/attributes/geonames/countryInfo?';
    if (query && query.lang) {
        url = url + `&lang=${query.lang}`
    }
    return secureFetch(url, {
        method: 'GET',
    });
}

export function getCities(query) {
    let url = API_BASE_URL +
        `/attributes/geonames/countryInfo/${query || query.countryCode ? query.countryCode : DEFAULT_COUNTRY_CODE}/city?`;
    if (query && query.lang) {
        url = url + `&lang=${query.lang}`
    }
    return secureFetch(url, {
        method: 'GET',
    });
}


// WEBPACK FOOTER //
// ./src/helpers/geoService.js